import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthContext';
import { authUtils } from '@/services/auth.api';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      if (!isLoading && !isAuthenticated) {
        if (authUtils.isAuthenticated()) {
          return;
        }

        navigate('/login', { replace: true });
      }
    };

    checkAuth();
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-meradio-cream flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin w-12 h-12 border-4 border-meradio-primary border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-meradio-dark-light font-medium">Checking authentication...</p>
          <p className="text-meradio-dark-light text-sm mt-2">Please wait while we verify your session</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <div className="min-h-screen bg-meradio-cream flex items-center justify-center">
        <div className="text-center">
          <div className="animate-pulse">
            <div className="w-16 h-16 bg-meradio-primary rounded-full mx-auto mb-4 opacity-50"></div>
          </div>
          <p className="text-meradio-dark-light">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
